export enum ScheduledTaskAction {
    Refresh = 'refresh',
    Start = 'start',
    Stop = 'stop',
    Enable = 'enable',
    Disable = 'disable',
}
